<template>
  <div class="tabs-vertical">
    <ul class="tabs-inner">
      <li v-for="(tab, index) in tabs" :key="tab.name">
        <a :class="{'active': isTabActive(index)}" @click="selectTab(index)">
          {{tab.name}}
          <span v-if="(search||displayNumbers) && itemCounter(tab)" class="tab-number">{{itemCounter(tab)}}</span>
          <i class="icon-arrow" v-else></i>
        </a>
        <ul v-if="tab.subtabs && tab.subtabs.length">
          <template v-for="(subTab, subIndex) in tab.subtabs" >
            <li :key="subTab.name" v-if="!search || (search && itemCounter(subTab))">
              <a @click="selectTab(index, subIndex)" :class="{'active': isSubTabActive(index, subIndex)}">
                <span>{{subTab.name}}</span>
                <span v-if="search || displayNumbers" class="tab-number">{{itemCounter(subTab)}}</span>
              </a>
            </li>
          </template>

        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import {slugify} from "@/helpers/slugify";
import {objectDeepEqual} from "@/helpers/objectDeepEqual";

export default {
props: {
  tabs: {
    type: Array,
    required: true,
  },
  search: {
    type: String,
    required: false,
  },
  displayNumbers: {
    required: false
  }
},
name: "TabMenuList",
methods: {
  slugify: slugify,
  selectTab(tabIndex, subTabIndex) {
    let query = {}
    if (tabIndex) {
      query = {
        tab: this.tabs[tabIndex].slug,
      }
    }

    if(subTabIndex && this.tabs[tabIndex].subtabs) {
      query.subtab = this.slugify(this.tabs[tabIndex].subtabs[subTabIndex].name)
    }

    if(!objectDeepEqual(query, this.$route.query)) {
      this.$router.push({query})
    }
    this.$emit('closeMenu')
  },
  isTabActive(index) {
    return this.$route.query.tab ? (this.tabs[index].slug === this.$route.query.tab) : !index
  },
  isSubTabActive(tabIndex, index) {
    if(this.isTabActive(tabIndex) && this.$route.query.subtab) {
      return this.slugify(this.tabs[tabIndex].subtabs[index].name) === this.$route.query.subtab
    }
    return index === 0 && this.isTabActive(tabIndex)
  },
  itemCounter(tab) {
    if(tab.type === 'solutions') {
      return tab.solutions.length
    }
    if(tab.type === 'files') {
      return tab.files.length
    }
  }
}
}
</script>

<style scoped>

</style>
